import React from 'react'
import { connect } from 'react-redux'
import { editSets } from "../../actions/settings"
import DeleteConfirmation from '../ui/DeleteConfirmation'
import SettingsItemForm from './SettingsItemForm'

class SetsRequItem extends SettingsItemForm {

  modelName = 'requ'

  render() {
    const { data } = this.props;
    const { data: nData, errors } = this.state;

    const delConf = this.state.delConf ?
      <DeleteConfirmation
        onDelete={this.deleteItem}
        onCancel={this.toggleDelConf}
      />
      :
      '';

    if(this.state.editing){
      return(
        <tr>
          <td>
            {delConf}
            <div className="form-group">
              <input type="text" className="form-control"  value={nData.requ_desc}
                name="requ_desc" onChange={this.updateInput}
                placeholder="Краткое название" autoFocus />
            </div>
            <div className="form-inline">
              <button  type="button" className="btn btn-success"
                onClick={this.saveItem} title="Сохранить">
                <span className="glyphicon glyphicon-save"></span>
              </button>{" "}
              <button type="button" className="btn btn-default"
                onClick={this.cancelEditing} title="Отменить">
                <span className="glyphicon glyphicon-remove"></span>
              </button>{" "}
              <button type="button" className="btn btn-danger"
                onClick={this.toggleDelConf} title="Удалить">
                <span className="glyphicon glyphicon-trash"></span>
              </button>
            </div>
            {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          </td>
          <td>
            <textarea type="text" className="form-control" value={nData.requ_long}
              name="requ_long" onChange={this.updateInput} rows="5"/>
          </td>
          <td>
            <textarea type="text" className="form-control" value={nData.requ_addr}
              name="requ_addr" onChange={this.updateInput}
              placeholder="Адрес" title="Адрес" />
            <input type="text" className="form-control"  value={nData.requ_inn}
              name="requ_inn" onChange={this.updateInput}
              placeholder="ИНН" title="ИНН" />
            <input type="text" className="form-control"  value={nData.requ_kpp}
              name="requ_kpp" onChange={this.updateInput}
              placeholder="КПП" title="КПП" />
            <input type="text" className="form-control"  value={nData.requ_dir}
              name="requ_dir" onChange={this.updateInput}
              placeholder="Директор" title="Директор" />
            <input type="text" className="form-control"  value={nData.requ_buh}
              name="requ_buh" onChange={this.updateInput}
              placeholder="Гл. бухгалтер" title="Гл. бухгалтер" />
          </td>
          <td>
            <textarea type="text" className="form-control" value={nData.requ_bname}
              name="requ_bname" onChange={this.updateInput}
              placeholder="Банк" title="Банк" />
            <textarea type="text" className="form-control" value={nData.requ_baddr}
              name="requ_baddr" onChange={this.updateInput}
              placeholder="Адрес" title="Адрес" />
            <input type="text" className="form-control"  value={nData.requ_bik}
              name="requ_bik" onChange={this.updateInput}
              placeholder="БИК" title="БИК" />
            <input type="text" className="form-control"  value={nData.requ_cacc}
              name="requ_cacc" onChange={this.updateInput}
              placeholder="Р/с" title="Р/с" />
            <input type="text" className="form-control"  value={nData.requ_bacc}
              name="requ_bacc" onChange={this.updateInput}
              placeholder="К/с" title="К/с" />
          </td>
        </tr>
      );
    }
    else{
      return (
        <tr onClick={this.startEditing}>
          <td>{data.requ_desc}</td>
          <td>{data.requ_long}</td>
          <td>
            {data.requ_addr}<br />
            {data.requ_inn}<br />
            {data.requ_kpp}<br />
            {data.requ_dir}<br />
            {data.requ_buh}
          </td>
          <td>
            {data.requ_bname}<br />
            {data.requ_bik}<br />
            {data.requ_baddr}<br />
            {data.requ_cacc}<br />
            {data.requ_bacc}
          </td>
        </tr>
      );
    }

  }
}

export default connect(null, { editSets })(SetsRequItem);



// WEBPACK FOOTER //
// ./src/components/settings/SetsRequItem.js